const TagField = (tagFieldProps: React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    {...tagFieldProps}
    className={`
    bg-gray-100 p-2 rounded text-sm
    ${tagFieldProps.className}
    `}
  />
);

export default TagField;
